import { HttpErrorResponse, HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { OKTA_AUTH } from "@okta/okta-angular";
import { OktaAuth } from "@okta/okta-auth-js";
import { catchError, finalize, from, mergeMap } from "rxjs";
import { AppRoutePaths, AppRoutes } from "../shared/common/app-path.routes";
import { GlobalServiceService } from "../shared/services/global-service.service";
import { UsersService } from "./users.service";
import { LogsModel } from "../shared/models/log.model";
import { LoaderService } from 'src/app/core/Loader.services';

export const securityInterceptor: HttpInterceptorFn = (req, next) => {
  const oktaAuth = inject<OktaAuth>(OKTA_AUTH);
  const router = inject(Router);
  const gbService = inject(GlobalServiceService);
  const userService = inject(UsersService);
  const loader = inject(LoaderService);

  //loader.show();
  return from(oktaAuth.tokenManager.get("accessToken")).pipe(
    mergeMap((tk: any) => {
      // const tokenStr = tk?.accessToken ?? tk; // handle object or string
      
      //loader.show();
      const tokenStr = gbService.getCPToken(); // handle object or string
      if (tokenStr) {
        req = req.clone({
          setHeaders: {
            Authorization: `Bearer ${tokenStr}`,
          },
        });
      }
      //loader.hide();
      return next(req).pipe(finalize(()=>{ loader.hide() }));
      //return next(req);
      
    }),
    catchError((error: HttpErrorResponse) => {
      // Optionally, handle specific status codes
      if (error.status === 401) {
        // Redirect to login or refresh token
        console.warn("Unauthorized! Redirecting to login...");
        router.navigateByUrl(AppRoutePaths[AppRoutes.Login]);
      }
      //Global Error
      // userService.errorLogger(error, req);

      console.error("Error in securityInterceptor:", error);
      
      return next(req).pipe(finalize(()=>{ loader.hide() }));
      //return next(req);
    })
  );
};
